export const MONO = "var(--app-font-mono)"
export const CHAT_COLOR = "var(--feature-chat)"
export const MIN_W = 320
export const MAX_W = 660
export const MIN_H = 260
export const MAX_H = 720
export const DEFAULT_W = 390
export const DEFAULT_H = 480
export const POLL_MS = 1000

export const EMOJIS = [
  "😀","😊","😂","🔥","💯","👍","❤️","🚀","🎯","✅",
  "⚠️","🔑","💡","🖥️","🐛","🔧","📁","📝","🕐","💬",
  "😎","🤔","👀","🎉","🛠️","⚡","🌙","🔐","🧠","📦",
]

export const AGENT_COLORS = { jarvis: "var(--agent-jarvis)", friday: "var(--agent-friday)" }
export const QUICK_REACTIONS = ["👍", "❤️", "😂", "🎉", "🔥", "✅"]
export const META_POLL_MS = 2500
export const MARKUP_RE = /\[\[([^[\]]*)\]\]|@(\w+)/g

// Allowlist mirrors backend _ALLOWED_FILE_TYPES (views/messenger.py) — kept here only for the
// file picker's `accept` attribute and instant client-side feedback; the server re-validates.
export const ALLOWED_FILE_EXTENSIONS = [".pdf", ".txt", ".log", ".csv", ".md", ".json", ".zip", ".gz", ".tar"]
export const MAX_FILE_BYTES = 8 * 1024 * 1024

export const EFFECT_SHADOW = {
  sparks: "0 0 14px 4px rgba(245,158,11,0.55)",
  matrix: "0 0 14px 4px rgba(34,197,94,0.55)",
  ripple: "0 0 0 6px rgba(245,158,11,0.18)",
}
